var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldcardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.1 20",
    style: {
      enableBackground: "new 0 0 15.1 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3C3C3C;}\r\n\t.st1{fill:#FFCA00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    transform: "translate(-734.352 -798.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    transform: "translate(734.352 798.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_256"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,19.8c-1,0-1.8-0.8-1.8-1.8V2C0.2,1,1,0.2,2,0.2h11.1c1,0,1.8,0.8,1.8,1.8v16c0,1-0.8,1.8-1.8,1.8H2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.1,0.5c0.8,0,1.5,0.7,1.5,1.5v16c0,0.8-0.7,1.5-1.5,1.5H2c-0.8,0-1.5-0.7-1.5-1.5V2 c0-0.8,0.7-1.5,1.5-1.5H13.1 M13.1,0H2C0.9,0,0,0.9,0,2v16c0,1.1,0.9,2,2,2h11.1c1.1,0,2-0.9,2-2V2C15.1,0.9,14.2,0,13.1,0 L13.1,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    transform: "translate(3.39 6.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    className: "st1",
    d: "M-0.3,7.5c0.6-0.7,1.1-1.2,1.6-1.8C3,3.8,4.7,2,6.4,0.1c0.2-0.2,0.4-0.4,0.7-0.3 c0.5,0,0.9,0,1.4,0v7.8H7V1.3C6.8,1.5,6.7,1.6,6.6,1.7C5,3.5,3.5,5.3,1.9,7.1C1.7,7.4,1.4,7.5,1,7.5C0.6,7.4,0.3,7.5-0.3,7.5z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldcardIcon);
export default __webpack_public_path__ + "static/media/goldcard_icon.0200b4a7.svg";
export { ForwardRef as ReactComponent };